import { API, Endpoints, PageModel } from "@brg/api";
import {
    Divider,
    StatsContainer,
    StatsContent,
    StatsNumber,
    StatsSection,
    StatsText,
    DateText,
    NoConnectionText,
} from "./styles";
import { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";

const UPDATE_INTERVAL_MINUTES = 60;

const formatDate = (date: Date) => {
    return date.toLocaleDateString('ru-RU', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    }).replace(/\./g, '-') + ' ' + date.toLocaleTimeString('ru-RU', {
        hour: '2-digit',
        minute: '2-digit',
    });
};

const checkOnline = () => {
    if (typeof navigator === 'undefined') {
        return true;
    }
    return navigator.onLine;
};

const addNumberSeparator = (value: number) => {
    if (value === undefined) {
        return '0';
    }
    return value.toLocaleString('ru-RU', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).replace(/\s/g, '.');
};

const Stats = () => {
    const [stats, setStats] = useState({
        projects: 0,
        cards: 0,
    });

    const [storedStats, setStoredStats] = useState({
        projects: 0,
        cards: 0,
    });

    const [lastUpdated, setLastUpdated] = useState(new Date());
    const [isNight, setIsNight] = useState(false);
    const [isOnline, setIsOnline] = useState(checkOnline());
   
    const lastCronUpdateKeyRef = useRef<string | null>(null);
    const lastMidnightReloadKeyRef = useRef<string | null>(null);

    const updateStats = () => {
        const isOnline = checkOnline();
        if (!isOnline) {
            setIsOnline(false);
            return;
        }
        API.request()
            .endpoint(Endpoints.geograffee)
            .url(`api/project/GetPublishedProjectsAndCardsCount`)
            .send()
            .then((v) => {
                if (v.status === 200) {
                    return v.json();
                } else {
                    setIsOnline(false);
                }
            })
            .then((v) => {
                if (!v) {
                    return;
                }
                const newStats = {
                    projects: v.publishedProjectsCount,
                    cards: v.publishedCardsCount,
                };
                setStats(newStats);
                localStorage.setItem('brg-stats', JSON.stringify(newStats));
                setLastUpdated(new Date());
                setIsOnline(true);
            })
            .catch(() => {
                setIsOnline(false);
            });
    };

    useEffect(() => {
        if (typeof window === 'undefined') {
            return;
        }
        const onOnline = () => {
            setIsOnline(true);
            updateStats();
        };
        const onOffline = () => {
            setIsOnline(false);
        };
        window.addEventListener('online', onOnline);
        window.addEventListener('offline', onOffline);
        return () => {
            window.removeEventListener('online', onOnline);
            window.removeEventListener('offline', onOffline);
        };
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            const now = new Date();
            const hours = now.getHours();
            const minutes = now.getMinutes();
            if (hours >= 20 || hours < 6) {
                setIsNight(true);
            } else {
                setIsNight(false);
            }

            if (hours === 0 && minutes === 0 && typeof window !== 'undefined') {
                const reloadKey = `${now.getFullYear()}-${now.getMonth()}-${now.getDate()}`;
                if (lastMidnightReloadKeyRef.current !== reloadKey) {
                    lastMidnightReloadKeyRef.current = reloadKey;
                    window.location.reload();
                    return;
                }
            }

            const minutesSinceMidnight = hours * 60 + minutes;
            if (minutesSinceMidnight % UPDATE_INTERVAL_MINUTES === 0) {
                const key = `${now.getFullYear()}-${now.getMonth()}-${now.getDate()}-${minutesSinceMidnight}`;
                if (lastCronUpdateKeyRef.current !== key) {
                    lastCronUpdateKeyRef.current = key;
                    updateStats();
                }
            }
        }, 1000 * 60);
        return () => clearInterval(interval);
    }, []);

    const formattedDate = formatDate(lastUpdated);

    useEffect(() => {
        const storedStats = localStorage.getItem('brg-stats');
        if (storedStats) {
            setStoredStats(JSON.parse(storedStats));
        }
    }, []);

    useEffect(() => {
        updateStats();
    }, []);

    if (isNight) {
        return <StatsContainer style={{ background: '#000' }}>
        </StatsContainer>;
    }

    return <StatsContainer>
        <Helmet>
            <title>Статистика платформы</title>
        </Helmet>
        <StatsContent>
            <StatsSection>
                <StatsText>проекты</StatsText>
                <StatsNumber>{addNumberSeparator(stats.projects || storedStats.projects)}</StatsNumber>
            </StatsSection>
            <Divider />
            <StatsSection>
                <StatsText>карточки</StatsText>
                <StatsNumber>{addNumberSeparator(stats.cards || storedStats.cards)}</StatsNumber>
            </StatsSection>
            {!isOnline ? <NoConnectionText>Нет сети</NoConnectionText>
                : <DateText>Обновлено {formattedDate}</DateText>}
        </StatsContent>
    </StatsContainer>;
};

export default Stats;import { API, Endpoints, PageModel } from "@brg/api";
import {
    Divider,
    StatsContainer,
    StatsContent,
    StatsNumber,
    StatsSection,
    StatsText,
    DateText,
    NoConnectionText,
} from "./styles";
import { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";

const UPDATE_INTERVAL_MINUTES = 60;

const formatDate = (date: Date) => {
    return date.toLocaleDateString('ru-RU', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    }).replace(/\./g, '-') + ' ' + date.toLocaleTimeString('ru-RU', {
        hour: '2-digit',
        minute: '2-digit',
    });
};

const checkOnline = () => {
    if (typeof navigator === 'undefined') {
        return true;
    }
    return navigator.onLine;
};

const addNumberSeparator = (value: number) => {
    if (value === undefined) {
        return '0';
    }
    return value.toLocaleString('ru-RU', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).replace(/\s/g, '.');
};

const Stats = () => {
    const [stats, setStats] = useState({
        projects: 0,
        cards: 0,
    });

    const [storedStats, setStoredStats] = useState({
        projects: 0,
        cards: 0,
    });

    const [lastUpdated, setLastUpdated] = useState(new Date());
    const [isNight, setIsNight] = useState(false);
    const [isOnline, setIsOnline] = useState(checkOnline());
   
    const lastCronUpdateKeyRef = useRef<string | null>(null);
    const lastMidnightReloadKeyRef = useRef<string | null>(null);

    const updateStats = () => {
        const isOnline = checkOnline();
        if (!isOnline) {
            setIsOnline(false);
            return;
        }
        API.request()
            .endpoint(Endpoints.geograffee)
            .url(`api/project/GetPublishedProjectsAndCardsCount`)
            .send()
            .then((v) => {
                if (v.status === 200) {
                    return v.json();
                } else {
                    setIsOnline(false);
                }
            })
            .then((v) => {
                if (!v) {
                    return;
                }
                const newStats = {
                    projects: v.publishedProjectsCount,
                    cards: v.publishedCardsCount,
                };
                setStats(newStats);
                localStorage.setItem('brg-stats', JSON.stringify(newStats));
                setLastUpdated(new Date());
                setIsOnline(true);
            })
            .catch(() => {
                setIsOnline(false);
            });
    };

    useEffect(() => {
        if (typeof window === 'undefined') {
            return;
        }
        const onOnline = () => {
            setIsOnline(true);
            updateStats();
        };
        const onOffline = () => {
            setIsOnline(false);
        };
        window.addEventListener('online', onOnline);
        window.addEventListener('offline', onOffline);
        return () => {
            window.removeEventListener('online', onOnline);
            window.removeEventListener('offline', onOffline);
        };
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            const now = new Date();
            const hours = now.getHours();
            const minutes = now.getMinutes();
            if (hours >= 20 || hours < 6) {
                setIsNight(true);
            } else {
                setIsNight(false);
            }

            if (hours === 0 && minutes === 0 && typeof window !== 'undefined') {
                const reloadKey = `${now.getFullYear()}-${now.getMonth()}-${now.getDate()}`;
                if (lastMidnightReloadKeyRef.current !== reloadKey) {
                    lastMidnightReloadKeyRef.current = reloadKey;
                    window.location.reload();
                    return;
                }
            }

            const minutesSinceMidnight = hours * 60 + minutes;
            if (minutesSinceMidnight % UPDATE_INTERVAL_MINUTES === 0) {
                const key = `${now.getFullYear()}-${now.getMonth()}-${now.getDate()}-${minutesSinceMidnight}`;
                if (lastCronUpdateKeyRef.current !== key) {
                    lastCronUpdateKeyRef.current = key;
                    updateStats();
                }
            }
        }, 1000 * 60);
        return () => clearInterval(interval);
    }, []);

    const formattedDate = formatDate(lastUpdated);

    useEffect(() => {
        const storedStats = localStorage.getItem('brg-stats');
        if (storedStats) {
            setStoredStats(JSON.parse(storedStats));
        }
    }, []);

    useEffect(() => {
        updateStats();
    }, []);

    if (isNight) {
        return <StatsContainer style={{ background: '#000' }}>
        </StatsContainer>;
    }

    return <StatsContainer>
        <Helmet>
            <title>Статистика платформы</title>
        </Helmet>
        <StatsContent>
            <StatsSection>
                <StatsText>проекты</StatsText>
                <StatsNumber>{addNumberSeparator(stats.projects || storedStats.projects)}</StatsNumber>
            </StatsSection>
            <Divider />
            <StatsSection>
                <StatsText>карточки</StatsText>
                <StatsNumber>{addNumberSeparator(stats.cards || storedStats.cards)}</StatsNumber>
            </StatsSection>
            {!isOnline ? <NoConnectionText>Нет сети</NoConnectionText>
                : <DateText>Обновлено {formattedDate}</DateText>}
        </StatsContent>
    </StatsContainer>;
};

export default Stats;